import { render, staticRenderFns } from "./ModalApprovalEpcs.vue?vue&type=template&id=ffa0ce68&scoped=true&"
import script from "./ModalApprovalEpcs.vue?vue&type=script&lang=js&"
export * from "./ModalApprovalEpcs.vue?vue&type=script&lang=js&"
import style0 from "./ModalApprovalEpcs.vue?vue&type=style&index=0&id=ffa0ce68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa0ce68",
  null
  
)

export default component.exports